import { flow, types, getEnv, getSnapshot } from 'mobx-state-tree'

import { AdminSponsorModel } from './'

const AdminSponsors = types
  .model('AdminSponsorModel', {
    content: types.optional(types.array(AdminSponsorModel), []),
    page: types.optional(types.number, 0),
    size: types.optional(types.number, 0),
    totalPages: types.optional(types.number, 1),
    sportType: types.optional(types.string, ''),
    name: types.optional(types.string, ''),
  })
  .actions((self) => {
    const {
      services: { adminSponsorsService },
    } = getEnv(self)

    const loadSponsorsGlobal = function* ({ name, sportType, page, size }) {
      const response = yield adminSponsorsService.querySponsors({
        name: name,
        sportType: sportType,
        page: page,
        size: size,
      })

      self.content = response.content
      self.totalPages = response.totalPages
      self.page = response.pageable.pageNumber
      self.size = response.pageable.pageSize
      self.name = name || ''
      self.sportType = sportType || ''

      return getSnapshot(self)
    }

    const sponsorAdded = () => {
      self.page = self.totalPages - 1
    }

    return {
      loadSponsors: flow(({ name, sportType, page, size }) =>
        loadSponsorsGlobal({ name, sportType, page, size })
      ),
      onSponsorAdded: sponsorAdded,
    }
  })

export const AdminSponsorsRoot = types.model('AdminSponsors', {
  adminSponsors: types.optional(AdminSponsors, {}),
})
